import React, {useState} from 'react';
import { View, Text, Switch, TextInput } from 'react-native';
import styles from '@stylesheet';
import { ValidationType } from '../types/validatorTypes';
import updateStoreHandler from '../utils/updateStoreHandler';
import ComponentRenderer from './ComponentRenderer';
import defaultValComponents, { ValidationComponentType } from '../utils/defaultValComponents';

const CheckboxValidation = ({item,  index }: ValidationType) => {

  // Bring in the default components and push new values in
  const validationComponents: ValidationComponentType[] = [
    ...defaultValComponents,
  ];

  validationComponents.push(
    { key: 'defaultValue', label: 'Default Value', type: 'switch' },
    { key: 'options', label: 'Options', type: 'options' },
    { key: 'minSelections', label: 'Min Selections', type: 'textInput', inputMode: 'numeric' },
    { key: 'maxSelections', label: 'Max Selections', type: 'textInput', inputMode: 'numeric' },
    { key: 'allowOther', label: 'Allow Other?', type: 'switch' },
  );


  return (
    <View style={[styles.validationView, { flexWrap: 'wrap' }]}>
      {validationComponents.map((component) => (
        <View key={component.key} style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', position: 'relative', flexWrap: 'wrap' }}>
          {
            component.type === 'switch' &&
            <Text style={{ flex: 1 }}>{component.label}</Text>
          }
          <ComponentRenderer item={item} component={component} index={index} />
        </View>
      ))}
    </View>
  );
};

export default CheckboxValidation;
